import { toast } from "@/components/common/Toast"
import { Button } from "@/components/ui/button"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { useCreatePortalSession } from "@/services/api/billingService"

/** Only a Stripe https URL may take the user off the app. */
export function isStripeUrl(url: string): boolean {
  try {
    const { protocol, hostname } = new URL(url)
    return (
      protocol === "https:" &&
      (hostname === "stripe.com" || hostname.endsWith(".stripe.com"))
    )
  } catch {
    return false
  }
}

interface ManagePlanButtonProps {
  variant?: "default" | "outline"
}

/** Opens the Stripe billing portal for the signed-in user. */
export const ManagePlanButton: React.FC<ManagePlanButtonProps> = ({
  variant = "default",
}) => {
  const { translate } = useTranslation()
  const portal = useCreatePortalSession()

  const open = () =>
    portal.mutate(undefined, {
      onSuccess: ({ url }) => {
        if (isStripeUrl(url)) window.location.assign(url)
        else toast.error(translate("UPGRADE/MANAGE_PLAN_ERROR"))
      },
      onError: () => toast.error(translate("UPGRADE/MANAGE_PLAN_ERROR")),
    })

  return (
    <Button variant={variant} disabled={portal.isPending} onClick={open}>
      {translate("UPGRADE/MANAGE_PLAN")}
    </Button>
  )
}
